module.exports = __webpack_public_path__ + "static/img/sm_5.a87fa5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_5.png
// module id = 59YV
// module chunks = 0